import React, {useState} from 'react'
import "./GalleryData.css"

import img1 from "../../assets/images/Silvina.jpeg";
import img2 from "../../assets/images/mconta2.jpeg";
import img3 from "../../assets/images/antonieta.jpeg";
import img4 from "../../assets/images/daniel.jpeg";
import img5 from "../../assets/images/Ailen.jpeg";
import img6 from "../../assets/images/trabajo.jpeg";
import img7 from "../../assets/images/patoserpa.jpeg";
import img8 from "../../assets/images/KarinaH.jpeg";
import img9 from "../../assets/images/mconta.jpeg";
import img10 from "../../assets/images/paolaE.jpeg";
import img11 from "../../assets/images/cnegro.jpeg";
import img12 from "../../assets/images/huerto.jpeg";
import img13 from "../../assets/images/Norita.jpeg";
import img14 from "../../assets/images/trabajo2.jpeg";
import img15 from "../../assets/images/virla.jpeg";
import img16 from "../../assets/images/trabajo1.jpeg";
import img17 from "../../assets/images/miguel.jpeg";
import img18 from "../../assets/images/mare.jpeg";
import img19 from "../../assets/images/alumno.jpeg";
import img20 from "../../assets/images/daniel1.jpeg";
import img21 from "../../assets/images/huerto2.jpeg";
import img22 from "../../assets/images/manuel.jpeg";
import img23 from "../../assets/images/trabajo4.jpeg";
import img24 from "../../assets/images/trabajo5.jpeg";
import img25 from "../../assets/images/trabajo6.jpeg";
import img26 from "../../assets/images/trabajo3.jpeg";
import img27 from "../../assets/images/torres.jpeg";
import img28 from "../../assets/images/claudia.jpeg";
import img29 from "../../assets/images/lili.jpeg";
import img30 from "../../assets/images/rude2.jpeg";
import img31 from "../../assets/images/rude.jpeg";
import img32 from "../../assets/images/alumnos.jpeg";
import img33 from "../../assets/images/guitarra.jpeg";
import img34 from "../../assets/images/lazo.jpeg";
import img35 from "../../assets/images/martinez.jpeg";
import img36 from "../../assets/images/brindis.jpeg";
import img37 from "../../assets/images/trabajo7.jpeg";
import img38 from "../../assets/images/agos.jpeg";
import img39 from "../../assets/images/daniel3.jpeg";
import img40 from "../../assets/images/manuel2.jpeg";
import img41 from "../../assets/images/manuel3.jpeg";
import img42 from "../../assets/images/cecilia.jpeg";
import img43 from "../../assets/images/trabajo8.jpeg";
import img44 from "../../assets/images/trabajo9.jpeg";
import img45 from "../../assets/images/trabajo10.jpeg";
import img46 from "../../assets/images/patoserpa1.jpeg";
import img47 from "../../assets/images/mconta3.jpeg";
import img48 from "../../assets/images/gomez.jpeg";
import img49 from "../../assets/images/martinez2.jpeg";
import img50 from "../../assets/images/huerto3.jpeg";
import img51 from "../../assets/images/huerto4.jpeg";


const GalleryData = () => {
    
    
    let data = [
        {
            id:1,
            imgSrc: img1,
        },
        {
            id:2,
            imgSrc:img2,
        },
        {
            id:3,
            imgSrc:img3,
        },
        {
            id:4,
            imgSrc:img4,
        },
        {
            id:5,
            imgSrc:img5,
        },
        {
            id:6,
            imgSrc:img6,
        },
        {
            id:7,
            imgSrc:img7,
        },
        {
            id:8,
            imgSrc:img8,
        },
        {
            id:9,
            imgSrc:img9,
        },
        {
            id:10,
            imgSrc:img10,
        },
        {
            id:11,
            imgSrc:img11,
        },
        {
            id:12,
            imgSrc:img12,
        },
        {
            id:13,
            imgSrc:img13,
        },
        {
            id:14,
            imgSrc:img14,
        },
        {
            id:15,
            imgSrc:img15,
        },
        {
            id:16,
            imgSrc:img16,
        },
        {
            id:17,
            imgSrc:img17,
        },
        {
            id:18,
            imgSrc:img18,
        },
        {
            id:19,
            imgSrc:img19,
        },
        {
            id:20,
            imgSrc:img20,
        },
        {
            id:21,
            imgSrc:img21,
        },
        {
            id:22,
            imgSrc:img22,
        },
        {
            id:23,
            imgSrc:img23,
        },
        {
            id:24,
            imgSrc:img24,
        },
        {
            id:25,
            imgSrc:img25,
        },
        {
            id:26,
            imgSrc:img26,
        },
        {
            id:27,
            imgSrc:img27,
        },
        {
            id:28,
            imgSrc:img28,
        },
        {
            id:29,
            imgSrc:img29,
        },
        {
            id:30,
            imgSrc:img30,
        },
        {
            id:31,
            imgSrc:img31,
        },
        {
            id:32,
            imgSrc:img32,
        },
        {
            id:33,
            imgSrc:img33,
        },
        
        {
            id:34,
            imgSrc:img34,
        },
        {
            id:35,
            imgSrc:img35,
        },
        {
            id:36,
            imgSrc:img36,
        },
        {
            id:37,
            imgSrc:img37,
        },
        {
            id:38,
            imgSrc:img38,
        },
        {
            id:39,
            imgSrc:img39,
        },
        {
            id:40,
            imgSrc:img40,
        },
        {
            id:41,
            imgSrc:img41,
        },
        {
            id:42,
            imgSrc:img42,
        },
        {
            id:43,
            imgSrc:img43,
        },
        {
            id:44,
            imgSrc:img44,
        },
        {
            id:45,
            imgSrc:img45,
        },
        {
            id:46,
            imgSrc:img46,
        },
        {
            id:47,
            imgSrc:img47,
        },
        {
            id:48,
            imgSrc:img48,
        },
        {
            id:49,
            imgSrc:img49,
        },
        {
            id:50,
            imgSrc:img50,
        },
        {
            id:51,
            imgSrc:img51,
        },
    ]
    

    const [model, setModel] = useState(false);
    const [tempimgSrc, setTempImgSrc] = useState ('');
    const getImg = (imgSrc) =>{
        setTempImgSrc (imgSrc);
        setModel(true); 

    }
    
    return (

        <>
        <div className={model ? "model open" : "model"} >
            <img src={tempimgSrc} alt="" /> 
        </div>
        
        <div className="gallery">
            {data.map((item, index) => {
                return (
                    <div className="pics" key={index} onClick={() => getImg(item.imgSrc)}>
                        <img src={item.imgSrc} style={{ width: '100%', height: '100%' }} alt="" />
                    </div>
                );
            })}
        </div></>
    )
    }






export default GalleryData